import { CustomLink } from '@/components/custom-link/CustomLink';
import type { NavbarFolderItem } from '@/shared/constant/navbar/NavbarItem';
import { Select } from 'aui';
import { FoxIconSort } from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import { NavbarGroupLevel, NavbarGroupType } from '../../type/NavbarGroupTypeLevel';
import { IconLabel } from '../icon-label/IconLabel';
import { NavbarElement } from '../navbar-element/NavbarElement';
import styles from './NavbarSelectList.module.css';

export type NavbarSelectListProps = {
  items: NavbarFolderItem[];
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export function NavbarSelectList(props: NavbarSelectListProps) {
  const { items, className, onClick } = props;

  const value = React.useMemo(() => {
    return items.find((x) => x.selected)?.id;
  }, [items]);

  return (
    <div className={className}>
      <Select
        className={clsx('w-full min-w-[120px]', styles.select)}
        value={value}
        options={items.map((x) => {
          return {
            label: (
              <CustomLink to={x.to} disabled={x.disabled} onClick={onClick}>
                <IconLabel
                  icon={x.icon}
                  label={x.title}
                  className="relative top-0 max-w-[560px] text-input max-os:top-[-1px]"
                />
              </CustomLink>
            ),
            value: x.id,
            to: x.to,
            disabled: x.disabled || !x.to,
          };
        })}
        popupClassName={styles['select-popup']}
        dropdownMatchSelectWidth={false}
        suffixIcon={<FoxIconSort className="text-input" />}
      />

      <ul className="hidden">
        {items.map((x) => {
          return (
            <li key={x.id}>
              <NavbarElement
                value={x}
                noBold={true}
                groupLevelType={{
                  level: NavbarGroupLevel.Level2,
                  type: NavbarGroupType.Select,
                }}
                onClick={onClick}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
